"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var PlannedRoutesEntity_1 = __importDefault(require("./Entity/PlannedRoutesEntity"));
var PlannedRoutes = /** @class */ (function () {
    function PlannedRoutes(session) {
        this.plannedRoutesEntity = new PlannedRoutesEntity_1.default(session);
    }
    PlannedRoutes.prototype.getAllByTeam = function (teamId, commonOptions) {
        return this.plannedRoutesEntity.getAllByTeam(teamId, commonOptions);
    };
    PlannedRoutes.prototype.getAll = function () {
        return this.plannedRoutesEntity.getAll();
    };
    PlannedRoutes.prototype.getBatchByTeamIds = function (teamIds, commonOptions) {
        return this.plannedRoutesEntity.getBatchByTeamIds(teamIds, commonOptions);
    };
    PlannedRoutes.prototype.getBatch = function (ids, options) {
        return this.plannedRoutesEntity.getBatch(ids, options);
    };
    PlannedRoutes.prototype.conflictPlannedRoutes = function (runId) {
        return this.plannedRoutesEntity.conflictPlannedRoutes(runId);
    };
    return PlannedRoutes;
}());
exports.default = PlannedRoutes;
//# sourceMappingURL=PlannedRoutesApi.js.map